/**
 * VG Collection Banner — mobile auto-slide
 *
 * Auto-advances the multi-image banner slider on mobile only.
 * On tablet/desktop the images render as a static row, so autoplay is disabled.
 * Activates on any [data-banner-slider] element with a [data-autoplay-speed] (seconds).
 */
(function () {
  var MOBILE = window.matchMedia('(max-width: 749px)');
  var RESUME_DELAY = 3000; // resume autoplay this long after a user interaction

  function initSlider(root) {
    var speed = (parseFloat(root.dataset.autoplaySpeed) || 4) * 1000;
    var items = root.querySelectorAll('.vg-collection-banner__media-item');
    if (items.length < 2) return;

    var timer = null;
    var resumeTimer = null;
    var interacting = false;

    function currentIndex() {
      return Math.round(root.scrollLeft / root.clientWidth);
    }

    function advance() {
      if (interacting || document.hidden) return;
      var next = (currentIndex() + 1) % items.length;
      root.scrollTo({ left: next * root.clientWidth, behavior: 'smooth' });
    }

    function start() {
      stop();
      if (!MOBILE.matches) return;
      timer = window.setInterval(advance, speed);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function pause() {
      interacting = true;
      window.clearTimeout(resumeTimer);
    }

    function scheduleResume() {
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        interacting = false;
      }, RESUME_DELAY);
    }

    // Pause while the user is swiping, resume shortly after they stop.
    root.addEventListener('pointerdown', pause);
    root.addEventListener('touchstart', pause, { passive: true });
    root.addEventListener('pointerup', scheduleResume);
    root.addEventListener('touchend', scheduleResume, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    // Start/stop when crossing the mobile breakpoint.
    var onChange = function () {
      if (MOBILE.matches) {
        start();
      } else {
        stop();
      }
    };
    if (MOBILE.addEventListener) {
      MOBILE.addEventListener('change', onChange);
    } else if (MOBILE.addListener) {
      MOBILE.addListener(onChange);
    }

    start();
  }

  function init() {
    document.querySelectorAll('[data-banner-slider]').forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
